import React from 'react'
import Layout from '../Layout/Layout'
import styled from 'styled-components'

const IndiverseFinale = () => {
  const finalists = [
    { name: "Laxmi Gaur", college: "Smt.Chandibai Himmatmal Mansukhani College" },
    { name: "Asavi Kapadia", college: "Jai Hind College" },
    { name: "Kajorika Chakraborty", college: "Smt chandibai Himathmal Mansukhani college" },
    { name: "Oishi Sengupta", college: "Scottish Church College" },
    { name: "Rizpah Samson", college: "Christ Church Jr Collage" },
    { name: "Rushika Patel", college: "Pandit Deendayal Energy University" },
    { name: "Violet D'souza", college: "St. Teresa's Institute Of Education" },
    { name: "Aman Gupta", college: "Smt.Chandibai Himmatmal Mansukhani College" },
    { name: "Gayatri Sunilkumar", college: "Kishinchand Chellaram Law College" },
    { name: "Anushri Majgonkar", college: "Hislop College" },
    { name: "Carol Fernando", college: "Smt.Chandibai Himmatmal Mansukhani College" },
    { name: "Kritarth Jain", college: "R.A. Podar College Of Commerce And Economics" },
    { name: "Yannichristy Anthony", college: "SICES Society's Degree College Of Arts, Science And Commerce" },
    { name: "Pratiksha Prabhu", college: "Smt.Chandibai Himmatmal Mansukhani College" },
    { name: "Ashirwad Das", college: "School of Creative Studies, D.Y. Patil University" },
    { name: "Tejasvee Nagar", college: "Sophia College" }
  ];

  return (
    <Layout>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#0f1817",
        }}
      >
        <Root>
          <Container>
            <Header>
              <Title>INDIVERSE</Title>
              <Subtitle>GRAND FINALE</Subtitle>
              <Winners>WINNERS</Winners>
            </Header>

            <WinnersSection>
              <WinnerCard>
                <Position>1st</Position>
                <WinnerName>Oishi Sengupta</WinnerName>
              </WinnerCard>
              <WinnerCard>
                <Position>2nd</Position>
                <WinnerName>Tejasvee Nagar</WinnerName>
              </WinnerCard>
              <WinnerCard>
                <Position>3rd</Position>
                <WinnerName>Aman Gupta</WinnerName>
              </WinnerCard>
            </WinnersSection>

            <Sponsor>SPONSORED BY PURPLE PROSE, BITS PILANI</Sponsor>

            <FinalistsSection>
              <FinalistsTitle>FINALISTS</FinalistsTitle>
              <FinalistsGrid>
                <FinalistsColumn>
                  {finalists.slice(0, 8).map((finalist, index) => (
                    <FinalistCard key={index}>
                      <FinalistName>{finalist.name}</FinalistName>
                      <CollegeName>{finalist.college}</CollegeName>
                    </FinalistCard>
                  ))}
                </FinalistsColumn>
                <FinalistsColumn>
                  {finalists.slice(8, 16).map((finalist, index) => (
                    <FinalistCard key={index}>
                      <FinalistName>{finalist.name}</FinalistName>
                      <CollegeName>{finalist.college}</CollegeName>
                    </FinalistCard>
                  ))}
                </FinalistsColumn>
              </FinalistsGrid>
            </FinalistsSection>

            <VideoSection>
              <VideoTitle>GRAND FINALE - VIDEO</VideoTitle>
              <YoutubeContainer>
                <iframe 
                  width="560" 
                  height="315" 
                  credentialless="true"
                  src="https://www.youtube.com/embed/Cojcfaul0tg?si=hCQ_HJqA4l6ogz7V" 
                  title="YouTube video player" 
                  frameBorder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                  referrerPolicy="strict-origin-when-cross-origin" 
                  allowFullScreen
                />
              </YoutubeContainer>
            </VideoSection>
          </Container>
        </Root>
      </div>
    </Layout>
  )
}

export default IndiverseFinale

const Root = styled.div`
  min-height: 100vh;
  height: auto;
  background-color: #0f1817;
  display: flex;
  max-width: 1300px;
  width: 100%;
  justify-content: center;
  padding: 20px;
  
  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const Container = styled.div`
  width: 100%;
  max-width: 800px;
  color: white;
  padding: 40px;
  
  @media (max-width: 768px) {
    padding: 20px;
    max-width: 100%;
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 40px;
`;

const Title = styled.h1`
  font-size: 60px;
  font-weight: bold;
  color: white;
  margin: 0;
  letter-spacing: 8px;
  
  @media (max-width: 768px) {
    font-size: 40px;
    letter-spacing: 4px;
  }
`;

const Subtitle = styled.h2`
  font-size: 32px;
  font-weight: bold;
  color: white;
  border-bottom: 3px solid white;
  padding-bottom: 8px;
  margin: 10px 0 5px 0;
  display: inline-block;
  
  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const Winners = styled.h3`
  font-size: 28px;
  font-weight: bold;
  color: white;
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 22px;
    }
   
`;

const WinnersSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 30px;
  margin: 40px 0;
  text-align: center;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 15px;
  }
  
  @media (max-width: 480px) {
    gap: 10px;
  }
`;

const WinnerCard = styled.div`
  text-align: center;
  flex: 1;
`;

const Position = styled.div`
  font-size: 26px;
  font-weight: bold;
  color: white;
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 4px;
  margin-bottom: 8px;
  
  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

const WinnerName = styled.div`
  font-size: 22px;
  font-weight: bold;
  color: white;
  
  @media (max-width: 768px) {
    font-size: 18px;
  }
     @media (max-width: 480px) {
        font-size: 16px;

  }
`;

const Sponsor = styled.div`
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: white;
  margin: 30px 0;
  padding: 10px 0;
  border-top: 1px solid white;
  border-bottom: 1px solid white;
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const FinalistsSection = styled.div`
  margin: 40px 0;
`;

const FinalistsTitle = styled.h3`
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  color: white;
  margin-bottom: 30px;
  
  @media (max-width: 768px) {
    font-size: 26px;
  }
`;

const FinalistsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  @media (min-width: 769px) and (max-width: 1024px) {
    gap: 30px;
  }
`;

const FinalistsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FinalistCard = styled.div`
  text-align: center;
  
  @media (max-width: 768px) {
    text-align: center;
  }
`;

const FinalistName = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: white;
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 3px;
  margin-bottom: 4px;
  
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const CollegeName = styled.div`
  font-size: 16px;
  color: white;
  
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const VideoSection = styled.div`
  margin-top: 10px;
  text-align: center;
  padding-top: 30px;
`;
  
const VideoTitle = styled.h3`
  font-size: 28px;
  font-weight: bold;
  color: white;
  
  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const YoutubeContainer = styled.div`
  display: flex;
  align-items: center;
  border-top: 2px solid white;
  justify-content: center;
  background-color: #0f1817;
padding-top:30px;
  border-radius: 8px;
  width: 100%;
  
  iframe {
    width: 100%;
    max-width: 100%;
    border-radius: 8px;
    aspect-ratio: 16/9;
  }
  
  @media (max-width: 768px) {
padding-top:15px;
    
    iframe {
      width: 100%;
      height: 200px;
    }
  }
  
  @media (min-width: 769px) and (max-width: 1024px) {

    
    iframe {
      width: 100%;
      height: 300px;
    }
  }
  
  @media (min-width: 1025px) {
    iframe {
      width: 100%;
      height: 300px;
    }
  }
`;